import React from 'react';
import { createRoot } from 'react-dom/client';
import providerHOC from '../utils/providerHOC/providerHOC';
import subscriptionForm from '../commonComponents/molecules/subscriptionForm';
import footerSubscriptionHOC from './footerSubscriptionHOC';

const FooterSubscriptionRoot = providerHOC()(footerSubscriptionHOC(subscriptionForm));
createRoot(document.getElementById('footerSubscription')).render(<FooterSubscriptionRoot />);
